import axios from 'axios'
import { handleResponse, handleError } from '../helpers/api'
import store from '../store'

const apClient = axios.create({
  baseURL: `${window.config.VUE_APP_API_BASE_URL}/OneProcess`,
  withCredentials: true
})

export const OneProcessService = {
  getJobs,
  deleteJob
}

async function getJobs(payload) {
  return await apClient
    .get('/jobs?' + new URLSearchParams(payload), getHeader())
    .then(handleResponse)
    .catch(e => {
      return handleError(e)
    })
}

async function deleteJob(payload) {
  return await apClient
    .delete('/jobs/' + payload, getHeader())
    .then(handleResponse)
    .catch(e => {
      return handleError(e)
    })
}

function getHeader() {
  return {
    headers: { Authorization: 'bearer ' + store.getters.jwtToken }
  }
}
